import React, { useState, useEffect } from 'react'
import { ButtonToolbar, Checkbox, Icon, Row, Table } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'

export default function ImportNodePreviewDataTable({
  schema,
  loading,
  onCancel = () => {},
  onSave = () => {},
}) {
  const { control } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [countSelected, setCountSelected] = useState(0)

  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema)
  }, [schema])

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {/* <b
            style={{
              color: rowData.isDupplicate ? '#fb8a81' : '',
            }}
          > */}
          {props.rowIndex + 1}
          {/* </b> */}
        </div>
      </Cell>
    )
  }

  const handleSave = () => {
    let newArr = []
    tableData.map((item) => {
      if (checkedKeys.includes(item.projectCode)) {
        newArr.push(item)
      }
    })

    onSave(newArr)
  }

  return (
    <>
      <Table
        wordWrap
        autoHeight
        loading={loading}
        data={tableData || []}
        style={{ marginTop: '20px' }}
      >
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={120}>
          <HeaderCell>ปีงบประมาณ</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>

        <Column width={120}>
          <HeaderCell>Node</HeaderCell>
          <Cell dataKey="node" />
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={150}>
          <HeaderCell>งบประมาณ</HeaderCell>
          {/* <Cell dataKey="budget" /> */}
          <Cell style={{textAlign: 'right'}}>
            {(rowData, index) => {
              return <span>{budgetFormat(rowData.budget)}</span>
            }}
          </Cell>
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>
      </Table>

    </>
  )
}
